import React, { useState } from 'react';
import  NavBarLeft, { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import NavigationBar from '../../ReusableComp/NavigationBar';
import Select from '../../ReusableComp/Select';
import { Col, Container, Row, Stack, Table } from 'react-bootstrap';
import moment from 'moment/moment';
// import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getPiList, getPiListStudies, getPiListSites} from '../../../Redux/actions/actions';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Loader from '../../ReusableComp/Loader';
import { Tooltip } from 'react-tooltip'
import { base_url } from '../../../utilities';



const PMSAdminPIList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [siteList, setSiteList] = useState([]); 
    const [studyList, setStudyList] = useState([]);
    const [zoneSelected, setZoneSelected] = useState("");
    const [studySelected, setStudySelected] = useState("");
    const piList = useSelector((state) => (state.piList));
    const piListStudies = useSelector((state) => (state.piListStudies));
    const piListSites = useSelector((state) => (state.piListSites));
    const [loading, setLoading] = useState(false);

   
    const [filteredData, setFilteredData] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [selectedPI, setSelectedPI] = useState(null)
    let [loading_flag, Setloading_flag] = useState(false);
    const [asc,setAsC]=useState(false);
    const [desc,setDesc]=useState(false);
    const [currentPage, setCurrentPage] = useState(1)



    useEffect(() => {
        Setloading_flag(true);
        dispatch(getPiList());
        dispatch(getPiListStudies())
        dispatch(getPiListSites())
        const siteListWithLabel = piList?.map(jsonObj => {
            return {
              value: jsonObj.pi_sites.site_name,
              label: jsonObj.pi_sites.site_name
            };
          });
          
          // Extract unique zoneIDs using Set
          const uniqueSiteSet = new Set(siteListWithLabel?.map(obj => obj.value));
          
          // Create a list of JSON objects with unique "value" and "label"
          const uniqueSiteList = [...uniqueSiteSet].map(val => ({
            value: val,
            label: val
          }));
          
          setSiteList(uniqueSiteList);

          const uniqueStudyNamesSet = new Set(
            piList?.flatMap(item => item.pi_studies?.map(study => study.study_name))
          );
          
          // Create a list of JSON objects with unique study_name as "value" and "label"
          const uniqueStudyNamesList = [...uniqueStudyNamesSet].map(studyName => ({
            value: studyName,
            label: studyName
          }));

          setStudyList(uniqueStudyNamesList);
    }, [dispatch]);

    useEffect(() => {
        if (piList) {
          setFilteredData(piList);
          setTimeout(()=>{
            Setloading_flag(false);
          },200)
        }
      }, [piList]);

      useEffect(() => {
        if (currentPage === 2) {
          window.scrollTo(0, 0);
        }
      }, [currentPage]);

    const exportToExcel = () => {
        const workbook = XLSX.utils.book_new();
        const sheetData = [];
      
        // Prepare the header row
        const headerRow = ['Name', 'Site', 'Studies'];
        sheetData.push(headerRow);
      
        // Prepare the data rows
        const dataRows = filteredData || piList;
        dataRows.forEach((item) => {
          const rowData = [
            item.name,
            item.pi_sites.site_name,
            item.pi_studies.map((study) => study.study_name).join(', '),
          ];
          sheetData.push(rowData);
        });
      
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      
        // Convert the workbook to an Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      
        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
        // Save the Blob as an Excel file
        saveAs(blob, 'Principal_Investigator_List.xlsx');
      };

    function disableBackButton() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', function(event) {
          window.history.pushState(null, null, window.location.pathname);
        });
      }
      useEffect(() => {
        disableBackButton();
      }, [])
 
const handleSubjectData =(data1)=>{
      navigate('/editprincipalinvestigator', { state: { data: data1 } });

}

const handleSubjectDataView =(data1)=>{
    setSelectedPI(data1);
    fetchImages();
    setCurrentPage(2)
}
const getRoleCode =(data)=>{
}
const handleOptionSelectSite =(e)=>{
    let val = e.target.value;
    if(val === "All Sites"){
        val = "";
    }
    setZoneSelected(val);
    const filteredData = piList?.filter(item => {
    if(item.pi_sites.site_name === null){
        item.pi_sites.site_name = "Aditya Birla Hyderabad";
    }
    if(studySelected !== ""){
        const hasMatchingStudyName = item.pi_studies.some(
            study => study.study_name && study.study_name.toLowerCase().includes(studySelected.toLowerCase())
            );
        return (
            item.pi_sites.site_name && item.pi_sites.site_name.toLowerCase().includes(val.toLowerCase()) && hasMatchingStudyName &&  item.name && item.name.toLowerCase().includes(searchText.toLowerCase())
        );
    }
    else{
        return (
            item.pi_sites && item.pi_sites.site_name.toLowerCase().includes(val.toLowerCase()) &&  item.name && item.name.toLowerCase().includes(searchText.toLowerCase())
        );
    }
  });
  setFilteredData(filteredData);

}

const handleOptionSelectStudy =(e)=>{
    let val = e.target.value;
    if(val === "All Studies"){
        val = "";
    }
    setStudySelected(val);
    
    const filteredData = piList?.filter(item => {
        if(item.pi_sites.site_name === null){
            item.pi_sites.site_name = "Aditya Birla Hyderabad";
        }
        const hasMatchingStudyName = item.pi_studies?.some(
            study => study.study_name?.toLowerCase().includes(val.toLowerCase())
        );
        
        return (
            item.pi_sites && item.pi_sites.site_name.toLowerCase().includes(zoneSelected.toLowerCase()) && hasMatchingStudyName &&  item.name && item.name.toLowerCase().includes(searchText.toLowerCase())
          );
        });
        setFilteredData(filteredData)
    }
    const handleClearFilters = () => {
        setZoneSelected("All Sites");
        setStudySelected("All Studies");
        setSearchText("");
        setFilteredData(piList);
        window.location.reload();
    }

    const handleSearchData = (event) => {
        const searchText = event.target.value.toLowerCase();
        setSearchText(searchText);
        const filteredData = piList?.filter((item) => {
            // Convert relevant properties to lowercase for case-insensitive search
            const hasMatchingStudyName = item.pi_studies?.some(
                study => study.study_name?.toLowerCase().includes(studySelected.toLowerCase())
            );
            return (
                item.name && item.name.toLowerCase().includes(searchText.toLowerCase()) && hasMatchingStudyName
                && item.pi_sites && item.pi_sites.site_name.toLowerCase().includes(zoneSelected.toLowerCase())
              );
        });
        // Update the table or do whatever you want with the filteredData
        setFilteredData(filteredData)

    }

    const handleBackClick = () => {
        setCurrentPage(1)
    }
   

const [studyOption, setStudyOption] = useState()

  const handleOptionChange=(e, key, value)=>{
    setStudyOption( value)
   }
   function convertToTitleCase(str) {
    return str?.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
const truncateLabel = (label) => {
    const maxLength = window.innerWidth < 768 ? 30 : 40;
    return label.length > maxLength ? `${label.slice(0, maxLength)}...` : label;
  };

  const handleAscending = () => {
    setAsC(true);
    setDesc(false);  
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const nameA = a.name || ''; 
      const nameB = b.name || ''; 
      return nameA.localeCompare(nameB);
    });
  
    
    setFilteredData(sortedData);
  };
  
  const handleDescending = () => {
    setDesc(true);
    setAsC(false);
  
    const sortedData = [...filteredData];
    sortedData.sort((a, b) => {
      const nameA = a.name || ''; 
      const nameB = b.name || '';
  
      return nameB.localeCompare(nameA);
    });
   
  
    setFilteredData(sortedData);
  };
 
  const calculateHeight = (numRecords) => {
    const minHeight = 35; // Minimum height for the td element
    const additionalHeightPerRecord = 20; // Additional height for each record
    const calculatedHeight = minHeight + numRecords * additionalHeightPerRecord;
    return calculatedHeight + "px";
  };


  function getIcon(fileExtension) {
    switch (fileExtension) {
        case 'pdf':
            return "./images/icons/reshot-icon-pdf.svg"
        case 'ppt':
            return "./images/icons/reshot-icon-ppt.svg"
        case 'txt':
            return "./images/icons/reshot-icon-txt.svg"
        case 'docx':
            return "./images/icons/reshot-icon-docx.svg"
        case 'doc':
            return "./images/icons/reshot-icon-doc.svg"
        case 'xls':
            return "./images/icons/reshot-icon-xls.svg"
        case 'csv':
            return "./images/icons/reshot-icon-csv.svg"
        case 'jpg':
            return "./images/icons/reshot-icon-jpg.svg"
        case 'png':
            return "./images/icons/reshot-icon-png.svg"
        case 'jpeg':
            return "./images/icons/reshot-icon-jpeg.svg"
        case 'xlsx':
            return "./images/icons/excel-svgrepo-com.svg"
    }
}
const fetchImages = async () => {
        if (selectedPI?.pi_resume != null && selectedPI?.pi_resume !== '') {
        setLoading(true)
          const queryParams = `?url=${selectedPI?.pi_resume}`;
          const response = await fetch(base_url + 'api/getImage' + queryParams);
          const data = await response.arrayBuffer();
          const base64 = btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
          selectedPI.image_url = `data:${response.headers.get('content-type')};base64,${base64}`;
          //return selectedPI;
        setLoading(false)
        }
   // setFilteredStudies(updatedStudies);
};

  const downloadFile =async  (fileUrl,typeOfDoc,document_name) => {
    await fetchImages();
    if(selectedPI.image_url!==undefined){   
    const validDocumentTypes = ["doc", "pdf", "docx", "txt", "ppt", "xls", "xlsx"];
    if (validDocumentTypes.includes(typeOfDoc)) {
    fetch(selectedPI.image_url)
    .then(response => response.blob())
    .then(blob => {
// Create a Blob from the binary data
const blobUrl = window.URL.createObjectURL(blob);

// Create a download link and trigger a click event
const downloadLink = document.createElement('a');
downloadLink.href = blobUrl;
downloadLink.download = document_name; // Set the desired file name
downloadLink.click();

// Clean up the URL.createObjectURL
window.URL.revokeObjectURL(blobUrl);
})
.catch(error => {
console.error('Error fetching file:', error);
});
}
else{
fetch(selectedPI.image_url)
.then(response => response.blob())
.then(blob => {
// Create a Blob from the binary data
const blobUrl = window.URL.createObjectURL(blob);
// Create a download link and trigger a click event
const downloadLink = document.createElement('a');
downloadLink.href = blobUrl;
// Set the appropriate file extension based on the image type
const extension = typeOfDoc === 'jpeg' ? 'jpg' : typeOfDoc;
downloadLink.download = document_name;
downloadLink.click();
// Clean up the URL.createObjectURL
window.URL.revokeObjectURL(blobUrl);
})
}
    }
}
    return (
        <div>
            <NavigationBar studyDropdwn={true} title={'Principal Investigator'} rolecode={getRoleCode} handleOptionChange={handleOptionChange}/>
            <div className='main_body '>
                {currentPage===1 && <Container fluid className='py-4 '>
                    <Stack direction="horizontal" gap={3} className=" mb-4" style={{padding:'0px 12px' }}>
                        <div>
                             {studyList && (
                                <select  onChange={handleOptionSelectStudy} className='custom-select' style={{ width: "auto" }}  >
                                <option value={"All Studies"}>All Studies </option>
                                {piListStudies?.map((option) => (
                                <option key={option.value} value={option.value}  title={option.label} >
                                    <div className={`label-style ${window.innerWidth < 768 ? 'mobile' : 'desktop'} `} >
                                        {window.innerWidth < 768
                                            ? option?.label?.length > 30 ? `${option.label.slice(0, 30)}...` : option.label 
                                            : option?.label?.length > 40 ? `${option.label.slice(0, 40)}...` : option.label}         
                                    </div>
                                    
                                </option>
                                ))}
                            </select>
                        )}
                        </div>
                        {siteList &&
                        <div>
                            
                                {/* <Select
                                selectdivstyl={""}
                                name={"classification"}
                                width={"auto"}
                                label={""}
                                options={piListSites}
                                initialValue={"All Sites"}
                                onChange={handleOptionSelectSite}
                            /> */}
                             <select onChange={handleOptionSelectSite} className='custom-select' style={{ width: "auto" }}  >
                                <option value={"All Sites"}>All Sites </option>
                                {piListSites?.map((option) => (
                                <option key={option.value} value={option.value}  title={option.label}>
                                    <div className={`label-style ${window.innerWidth < 768 ? 'mobile' : 'desktop'} `} >
                                        {window.innerWidth < 768
                                            ? option?.label?.length > 30 ? `${option.label.slice(0, 30)}...` : option.label 
                                            : option?.label?.length > 40 ? `${option.label.slice(0, 40)}...` : option.label}         
                                    </div>
                                    
                                </option>
                                ))}
                            </select>

                            
                        </div>
                        }
                        <div>
                            <button className="orange_btn" onClick={handleClearFilters}>Clear</button>
                        </div>

                        <div xs={3} className="ms-auto">
                            <button className="orange_btn" onClick={() =>navigate('/pmsadminaddpi')}>Add Principal Investigator</button>
                        </div>
                    </Stack>
                    <Container fluid className='pitable_container'>
                       
 <div>
      {loading_flag ? (
        // <Loader /> 
        <div className=''>
        <img
          className="atrium_loader"
          src="/images/circle-effect-loading.gif"
          alt="Loader"

        />
      </div>

      ) : (
        <div>
            <Row className='searchbar'>
                                <Col className='searchFiled gap-3'>
                                    <label htmlFor="" />
                                    <input type="text" value={searchText} onChange={handleSearchData} placeholder='Search with Name' />
                                    <div className=" ">
                                            <button
                                                className="btn btn-success "
                                                onClick={exportToExcel}
                                                style={{height:"42px"}}
                                            >
                                                Download XLS
                                                <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                                            </button>
            
                                        </div>
                                </Col>
                            </Row>
             <div className='table-scroll-container' style={{border:"1px solid #E1E5E7 "}}>
                            <Table bordered size="sm" className='pitable mb-0'>
                                <thead className='sticky_table_header' style={{height:window.scrollY> 50 ?"105px" :""}}>
                                    <tr>
                                        <th>S.No</th>
                                        <th className='sticky-header'>
                                            <div  style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                            <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40px" }}>Name</span>
                                                            <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                    <g id="icon_sort">
                                                                        <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                        <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                    </g>
                                                                </svg>
                                                                </div>
                                                                </th>
            
                                        <th>Site
                                        </th>
                                        <th>Site Address
                                        </th>
                                        <th>Studies
                                        </th>
                                        <th>Action
                                        </th>
                                    </tr>
                                </thead>
                                {filteredData === null ?
                                    <tbody className="tableBodyScroll1">
                                    {piList?.map((i, index)=>{
            
                                        return(
                                        <tr key={i.mh_id} className='text_left_table'>
                                        <td className='text_right_sno'>{index +1}</td>
                                        <td>{i.name ? convertToTitleCase(i.name):"-"}</td>
                                        <td data-tooltip-id={i.pi_sites.site_name} data-tooltip-content={i.pi_sites.site_name}  >
                                        {i.pi_sites.site_name?.length > 40
                                            ? i.pi_sites.site_name.slice(0, 40) + "...."
                                            : i.pi_sites.site_name}
                                        <Tooltip id={i.pi_sites.site_name}/>
                                        </td>
                                        <td data-tooltip-id={ i.pi_sites.site_address} data-tooltip-content={i.pi_sites.site_address}>
                                        {i.pi_sites.site_address ? i.pi_sites.site_address?.length > 40
                                            ? i.pi_sites.site_address.slice(0, 40) + "...."
                                            : i.pi_sites.site_address :"-"}
                                        <Tooltip id={i.pi_sites.site_address}/>
                                        </td>
                                        <td style={{display:"flex", flexDirection:"column", textAlign:"center", padding: (i.pi_studies?.length === 1) ? "0px" : "0px"}}>{i.pi_studies? i.pi_studies.map((j, index) => {
                                             const truncatedStudyName = j.study_name?.length > 30 ? j.study_name.substring(0, 30) + "..." : j.study_name;
                                            return(
                                                <span className='text_left_table' style={{fontWeight:"600"}}  data-tooltip-id={j.study_name} data-tooltip-content={j.study_name}>{truncatedStudyName}{index !== (i.pi_studies?.length - 1) ? ", " : ""}
                                                 <Tooltip className='tooltip_study'  id={j.study_name} style={{ zIndex: 20 }}/>
                                                </span>
                                            )
                                        }):"-"}</td>
                                        <td className='viewbtnstyl'>
                                            <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                                <button className="gray_btn px-3 button_right" style={{marginRight:"10PX",width:"130px" }} onClick={()=>handleSubjectData(i)}>Add to study</button>
                                                <button className="gray_btn px-3" onClick={()=>handleSubjectDataView(i)}>View</button>
                                            </div>
                                         </td>
                                    </tr>)})}
            
                                </tbody>
                                :
                                <>
                                  {filteredData?.length > 0?(
                                <tbody>
                                    {filteredData?.map((i, index)=>{
            
                                        return(
                                            <tr key={i.mh_id} className='text_left_table'>
                                        <td className='text_right_sno'>{index +1}</td>
                                        <td>{i.name ? i.name :"-"}</td>
                                        <td title={i.pi_sites.site_name ? i.pi_sites.site_name :"-"}>
                                        {i.pi_sites.site_name ? i.pi_sites.site_name :"-"?.length > 40
                                            ? i.pi_sites.site_name.slice(0, 40) + "...."
                                            : i.pi_sites.site_name}
            
                                        </td>
                                        <td title={i.pi_sites.site_address}>
                                        {i.pi_sites.site_address?.length > 40
                                            ? i.pi_sites.site_address.slice(0, 40) + "...."
                                            :
                                            i.pi_sites.site_address}
                                            {/* {i.pi_sites.site_address} */}
            
                                        </td>
                                        <td style={{width:"400px"}}>
                                        <div style={{display:"flex", flexDirection:"column",  height: calculateHeight(i.pi_studies.length)-"20px", textAlign:"center", padding: (i.pi_studies?.length === 1) ? "0px" : "0px"}}>{i.pi_studies.map((j, index) => {
                                            //  const truncatedStudyName = j.study_name?.length > 40 ? j.study_name.substring(0, 40) + "..." : j.study_name;
                                            return(
                                                <span className='mt-1 text_left_table'  style={{fontWeight:"600" , }} data-tooltip-id={j.study_name} data-tooltip-content={j.study_name}>{j.study_name}{index !== (i.pi_studies?.length - 1) ? ", " : ""}
            
                                                <Tooltip className='tooltip_study' id={j.study_name} style={{ zIndex: 20 }}/>
                                                </span>
                                            )
                                        })}</div>
                                        </td>
                                        <td className='viewbtnstyl'>
                                            <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                                <button className="gray_btn px-3 button_right" style={{marginRight:"10PX",width:"130px"}} onClick={()=>handleSubjectData(i)}>Add to study</button>
                                                <button className="gray_btn px-3"style={{marginRight:"10PX"}} onClick={()=>handleSubjectDataView(i)}>View</button>
                                            </div>
                                         </td>
                                    </tr>
                                    )})}
            
                                </tbody>
                                 )
                                 :
                                 (
            
                                     <tbody>
                                         <tr className='text-center'>
                                         <td colSpan='5'>No records found</td>
                                         </tr>
                                     </tbody>
            
                                 )
                                 }
                                 </>
            
                                }
            
                            </Table>
                            </div>
        </div>
      )
      
      }
    </div>
                        
                       



                    </Container>
                </Container>}
                {currentPage === 2 && selectedPI && 
                <>    {loading && <Loader />}
                  <Container fluid className='py-3 page_two_styl'>
                <Row className='d-flex justify-content-between'>
                    <Col><button className="white_btn white_btn_back" onClick={handleBackClick}>{'< '}Back</button> </Col>
                </Row>
                <Container fluid className='py-3 '>
                    <Row className='viewPage'>
                                <div style={{ margin: "24px 0px", paddingLeft:'32px' }} className='d-flex'>
                                    <p style={{ fontWeight: "bold", color: "black", fontSize:"20px"}}>Name: {selectedPI.name}</p>
                                    <p style={{lineHeight:"25px"}} className='mt-1'> <span style={{ fontWeight: "bold", color: "black", fontSize:"20px" ,marginLeft:"40px"}} className='me-1'>Resume:</span> {selectedPI.document_name}<img height="30px" width="50px" src={getIcon(selectedPI.document_type)} title='Click on the icon to download the file'  
                                    onClick={() => {downloadFile(selectedPI.image_url,selectedPI.document_type,selectedPI.document_name)}} style={{ cursor: "pointer" }}/></p>
                                </div>
                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px", width:"85vw"}}></div>
                                <div  style={{ display: "flex", flexDirection: "row", margin: "24px 0px 15px 0px", paddingLeft:"32px", justifyContent: "start", alignItems:"center"}}>
                                    <p style={{marginRight:"20px"}}>
                                        {selectedPI.contact_number}
                                        <img style={{ height: "20px", margin: "6px", paddingLeft: "5px" }} src="./images/icons/Phone Telephone by Streamlinehq (1).svg" alt="" />

                                    </p>
                                    <p style={{marginRight:"20px", fontWeight:"bolder"}}>.</p>
                                    <p style={{marginRight:"20px"}}>
                                        {selectedPI.email}
                                        <img style={{ height: "20px", margin: "5px" }} src="./images/icons/Mail Send Envelope by Streamlinehqmainemail.svg" alt="" />
                                    </p>
                                    <p style={{marginRight:"20px", fontWeight:"bolder"}}>.</p>
                                    <p style={{marginRight:"20px"}}>Aadhar: { "*".repeat(selectedPI.aadhar_card_number?.length - 4) + selectedPI.aadhar_card_number.slice(-4)}</p>

                            </div>

                            <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px", marginBottom:"32px", width:"85vw"}}></div>
                            {selectedPI.pi_studies?.map((i) => {
                            return(
                                <div className='piViewStudy' style={{width:"85vw"}}>
                                    <h5 className='ms-3'>{i.study_name}</h5>
                                    <div className='ms-3' style={{ border: "1px dotted #E1E5E7",  }}></div>
                                    <p className='ms-3' >Site Code: {selectedPI.pi_sites.site_code}</p>
                                    <p className='ms-3'>{selectedPI.pi_sites.site_name}</p>
                                    <p className='ms-3' >{selectedPI.pi_sites.site_address}</p>
                                    <p className='ms-3' >{selectedPI.pi_sites.phone_number}</p>
                                </div>
                            )
                        })

                        }
                    </Row>
                    
                </Container>
                    </Container>
                </>
              
                }
            </div>

        </div>
    );
};

export default PMSAdminPIList;

const Stepper = ({ events }) => {
    return (
        <Row className=''>
            <Col className='vertical_stepper_main col-3'>
                {events?.map((i, index) => {
                    return (
                        <div className='vertical_stepper_section' key={index}>
                            <Col className='dataleft'>
                                <div className='fs-6'>{i.day}</div>
                                <div className='date'>{moment(i.dateOfevent).format("DD-MM-YYYY")}</div>
                            </Col>

                        </div>
                    )
                })}
            </Col>
            <Col className='vertical_stepper_main'>
                <div className="vertical_stepper_dots  ">
                    {events?.map((i, index) => {
                        let yellowDot = i.eventClassification?.some(obj => Object.keys(obj).includes('adverse_events'))
                        let seriousDot = i.eventClassification?.some(obj => Object.keys(obj).includes('serious_adverse_events'))
                        return (
                            <div className='vertical_stepper_section' key={index}>

                                    <Col className={`dot ${seriousDot && yellowDot ? "C-red" : seriousDot&&!yellowDot? "C-red": !seriousDot && yellowDot ? "C-orange" : "C-gray"}`} />
                                    
                                        <div>
                                            {i.eventClassification?.map((i, index) => {

                                            return (<div key={index} className='' >
                                                <div className='d-flex' >
                                                    <div className='adveventstyl'>{i.adverse_events?.map((item, index) => (
                                                        <div key={index}>
                                                        {item}
                                                        {index !== i.adverse_events?.length - 1 ? ',' : ''}
                                                        </div>
                                                    ))}</div>
                                                    <div className='adveventstyl'>{i.serious_adverse_events?.map((item, index) => (
                                                        <div key={index}>
                                                        {item}
                                                        {index !== i.serious_adverse_events?.length - 1 ? ',' : ''}
                                                        </div>
                                                    ))}</div>
                                                </div>
                                            </div>)
                                                                        })}
                                        </div>
                                     

                            </div>
                        )
                    })}
                </div>
            </Col>
            {/* <Col className='vertical_stepper_main '>
                {events?.map((i, index) => {
                    let yellowDot = i.eventClassification?.some(obj => Object.keys(obj).includes('adverse_events'))
                    let seriousDot = i.eventClassification?.some(obj => Object.keys(obj).includes('serious_adverse_events'))
                    return (
                        <div className='' key={index}>


                            <Col className=''>{i.eventClassification?.map((i, index) => {
                                return <div key={index}>
                                    {i.adverse_events}{i.serious_adverse_events}


                                </div>
                            })}</Col>
                        </div>
                    )
                })}
            </Col> */}
        </Row>
    );
};

